import React, { useState, useRef, useEffect } from 'react'
import SectionCarousel from '../../landingPage/SectionCarousel';
import Section from '../../landingPage/Section';
import {CoE, CoIP, Clinics, Labs} from '../../../images/index'
import Slide from '../../../components/landingPage/Cards/SlideCards'
import useWindowSize from '../../../hooks/useWindowSize';

function NetworkSection() {

  const size = useWindowSize();

  const [ activeSlide, setActiveSlide ] = useState(0);
  const [imageSize, setImageSize] = useState({
    height: "",
    width: ""
  })
  
  const imgRef = useRef(null);

  useEffect(() => {
    let initialHeight;
    let initialWidth;
    if (size.width >= size.tailwind.md) {
      initialHeight = '376px';
      initialWidth = '375px';
    } else {
      initialHeight = '325px';
      initialWidth = '375px';
    }
    setImageSize({
      height: imgRef?.current?.offsetHeight || initialHeight,
      width: imgRef?.current?.offsetWidth || initialWidth
    })
  }, [size])

  const IMG_STYLE = {
    transition:"all .5s linear",
    maxWidth:`${size.width<size.tailwind.md ? "320px" : "375px"}`,
    width:"100%",
    objectPosition:"25% 0"
  }
  
  const IMG_CONTAINER = {
   height: imageSize.height,
   width: imageSize.width
  }
  
  return (
    <Section
      className="py-4 md:py-12"
      subtitleClassName="mb-6 lg:mb-0"
      title="XiViX"
      subtitle="The XiViX Network is an ecosytstem of partners that collaborate to deliver the best end-to-end dental services and render optimum wellness."
      id="Network"
    >
      <div className="flex flex-col items-center lg:flex-row lg:px-10">
        <div
          className="relative h-auto w-full sm:min-w-1/2 flex justify-around overflow-hidden"
          style={IMG_CONTAINER}
        >
          <img
            alt="network"
            ref={imgRef}
            id="imgRef3"
            className={`absolute object-contain lg:right-20 ${
              activeSlide === 2 ? "opacity-100" : "opacity-0"
            }`}
            src={Labs}
            style={IMG_STYLE}
          />
          <img
            alt="network"
            id="imgRef2"
            className={`absolute object-contain lg:right-20 ${
              activeSlide === 1 ? "opacity-100" : "opacity-0"
            }`}
            src={CoE}
            style={IMG_STYLE}
          />
          <img
            alt="network"
            id="imgRef1"
            className={`absolute object-contain lg:right-20 ${
              activeSlide === 0 ? "opacity-100" : "opacity-0"
            }`}
            src={CoIP}
            style={IMG_STYLE}
          />
          <img
            alt="network"
            id="imgRef4"
            className={`absolute object-contain lg:right-20 ${
              activeSlide === 3 ? "opacity-100" : "opacity-0"
            }`}
            src={Clinics}
            style={IMG_STYLE}
          />
        </div>
        <div className="w-full flex justify-around lg:justify-start sm:min-w-1/2 pt-4 sm:pt-6 lg:pt-20 lg:pb-10">
          <SectionCarousel
            activeSlide={activeSlide}
            setActiveSlide={setActiveSlide}
            slideCounter={4}
          >
            <Slide title="XiViX Centre of Intelligence, Planning & Productions (CIPP)">
              <div className="space-y-2">
                <p>
                  The CIPP oversees the entire ODD ecosystem, centralised AI
                  technologies and engineering.
                </p>
                <p>
                  It collaborates with the CoE to propose patiente treatment
                  plans, oversees design & prosthesis manufacture, and is
                  responsible for the centralised technology quality assurance
                  for protocols, materials and innovations.
                </p>
              </div>
            </Slide>
            <Slide title="XiViX Centre of Excellence (CoE)">
              <div className="space-y-2">
                <p>
                  The CoE houses clinical specialists and advanced equipment
                  such as 3D Scanners (Intra-Oral, Face & CBCT X-ray).
                </p>
                <p>
                  Pre-Prosthetic procedures, surgeries and meetings between
                  specialists are held here.
                </p>
              </div>
            </Slide>
            <Slide title="XiViX LABS">
              <div className="space-y-2">
                <p>They are the catalyst to XiViX's novel digital workflow.</p>
                <p>
                  Skilled ceramists & Lab technicians help customize
                  restorations & prosthetics with state of the art technologies.
                </p>
              </div>
            </Slide>
            <Slide title="XiViX Clinics">
              <div className="space-y-2">
                <p>
                  They can be the first point of care for patients & conduct
                  initial scans.
                </p>
                <p>
                  They conduct minor dental procedure, help deliver the final
                  prosthesis and may directly refer patients to a CoE for the
                  complete XiViX process.
                </p>
              </div>
            </Slide>
          </SectionCarousel>
        </div>
      </div>
    </Section>
  );
}

export default NetworkSection
